<div *ngIf="isLoading" class="overlay">
  <div class="spinner"></div>
</div>
